@if (isLoading$ | async) {
  <div class="flex items-center justify-center h-96">
    <loading-spinner></loading-spinner>
  </div>
} @else {
  <div>
    <page-header
      [title]="pageTitle"
      [noMargin]="true"
      [canGoBack]="true"
      [subTitle]="'Manage ' + pageTitle.toLowerCase() + ' submissions.'"
    ></page-header>

    <div class="flex-1 flex flex-col overflow-hidden">
      <div class="flex-1 overflow-y-auto py-6 px-4">
        <div class="mx-auto grid grid-cols-12 gap-8">
          <div
            [ngClass]="
              isReadOnlyView
                ? 'col-span-12 lg:col-span-12 space-y-6'
                : 'col-span-12 lg:col-span-8 space-y-6'
            "
          >
            <div class="flex flex-col md:flex-row md:items-end justify-between gap-4">
              <div>
                <h2 class="text-4xl font-black tracking-tight text-slate-900 dark:text-slate-100">
                  {{ currentCompanyName || '-' }}
                </h2>
                <p class="text-slate-500 mt-1 flex items-center gap-2">
                  <mat-icon class="text-sm">calendar_today</mat-icon>
                  Created on
                  {{
                    (viewType === 'cash' ? cashGuarantee?.createdAt : manualGuarantee?.createdAt)
                      | date: 'medium'
                  }}
                </p>
              </div>
              <div class="flex items-center">
                <span
                  class="inline-flex items-center rounded-full border px-3 py-1.5 text-xs font-bold gap-1.5"
                  [ngClass]="statusStyle.getStatusClass(currentStatus, 'status')"
                >
                  <span class="size-2 rounded-full animate-pulse" [ngClass]="statusStyle.getStatusConfig(currentStatus, 'status').dotClass || 'bg-gray-400'"></span>
                  {{ statusStyle.formatStatusLabel(currentStatus) }}
                </span>
              </div>
            </div>

            <div
              class="bg-primary rounded-xl p-8 shadow-xl shadow-primary/20 relative overflow-hidden group"
            >
              <div
                class="absolute -right-8 -bottom-8 opacity-10 group-hover:scale-110 transition-transform duration-700"
              >
                <mat-icon class="text-[160px]">payments</mat-icon>
              </div>
              <p
                class="text-primary-foreground/80 text-white font-bold uppercase tracking-widest text-xs mb-2"
              >
                Total Security Amount
              </p>
              <div class="flex items-baseline gap-3">
                <h3 class="text-white text-5xl font-black">{{ currentAmount }}</h3>
                <!-- <span class="text-white text-xl font-bold uppercase">{{
                currentCurrency || '-'
              }}</span> -->
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div
                class="bg-white dark:bg-slate-900 rounded-xl p-6 border border-slate-200 dark:border-slate-800 shadow-sm"
              >
                <div class="flex items-center gap-2 mb-6">
                  <mat-icon class="text-primary">account_balance</mat-icon>
                  <h4 class="font-bold text-slate-900 dark:text-slate-100">Bank Information</h4>
                </div>
                <div class="space-y-4">
                  <div class="flex flex-col">
                    <span class="text-[10px] uppercase font-bold text-slate-400 tracking-wider"
                      >Financial Institution</span
                    >
                    <span class="font-semibold text-slate-700 dark:text-slate-300">{{
                      currentBankName || '-'
                    }}</span>
                  </div>
                  <div class="grid grid-cols-2">
                    <div class="flex flex-col">
                      <span class="text-[10px] uppercase font-bold text-slate-400 tracking-wider">{{
                        viewType === 'cash' ? 'Deposit Date' : 'Issue Date'
                      }}</span>
                      <span class="font-semibold text-slate-700 dark:text-slate-300">{{
                        currentDate | date: 'mediumDate'
                      }}</span>
                    </div>
                    @if (viewType === 'manual') {
                      <div class="flex flex-col">
                        <span class="text-[10px] uppercase font-bold text-slate-400 tracking-wider"
                          >Expiry Date</span
                        >
                        <span class="font-semibold text-red-800 dark:text-slate-300">{{
                          expireDate | date: 'mediumDate'
                        }}</span>
                      </div>
                    }
                  </div>
                  <div class="flex flex-col">
                    <span class="text-[10px] uppercase font-bold text-slate-400 tracking-wider"
                      >Currency Type</span
                    >
                    <span class="font-semibold text-slate-700 dark:text-slate-300">{{
                      currentCurrency || '-'
                    }}</span>
                  </div>
                </div>
              </div>

              <div
                class="bg-white dark:bg-slate-900 rounded-xl p-6 border border-slate-200 dark:border-slate-800 shadow-sm"
              >
                <div class="flex items-center gap-2 mb-6">
                  <mat-icon class="text-primary">app_registration</mat-icon>
                  <h4 class="font-bold text-slate-900 dark:text-slate-100">Registration Details</h4>
                </div>
                <div class="space-y-4">
                  <div class="flex flex-col">
                    <span class="text-[10px] uppercase font-bold text-slate-400 tracking-wider"
                      >Internal Reference</span
                    >
                    <span class="font-semibold text-slate-700 dark:text-slate-300">{{
                      currentReference || '-'
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-[10px] uppercase font-bold text-slate-400 tracking-wider"
                      >Registration Type</span
                    >
                    <span class="font-semibold text-slate-700 dark:text-slate-300">{{
                      currentRegistrationType || '-'
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-[10px] uppercase font-bold text-slate-400 tracking-wider"
                      >Regulatory Class</span
                    >
                    <span class="font-semibold text-slate-700 dark:text-slate-300">{{
                      currentVisibility || '-'
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden"
            >
              <div
                class="px-6 py-4 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between"
              >
                <div class="flex items-center gap-2">
                  <mat-icon class="text-primary">attachment</mat-icon>
                  <h4 class="font-bold">Supporting Documents</h4>
                </div>
                <span class="text-xs text-slate-400 font-medium"
                  >{{ attachments.length }} Files Attached</span
                >
              </div>
              <div class="divide-y divide-slate-100 dark:divide-slate-800">
                @if (!attachments.length) {
                  <div class="px-6 py-4 text-sm text-slate-500">No attachments found.</div>
                } @else {
                  @for (attachment of attachments; track attachment.uuid || $index) {
                    <div
                      class="px-6 py-4 flex items-center justify-between hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
                    >
                      <div class="flex items-center gap-4">
                        <div
                          class="bg-slate-50 dark:bg-slate-800 p-2 rounded text-slate-600 dark:text-slate-300"
                        >
                          <mat-icon class="block">{{
                            getAttachmentIcon(attachment.attachmentType?.fileType)
                          }}</mat-icon>
                        </div>
                        <div>
                          <p class="text-sm font-semibold text-slate-700 dark:text-slate-200">
                            {{ getAttachmentName(attachment) }}
                          </p>
                          <p class="text-[10px] text-slate-500 uppercase font-bold">
                            {{ attachment.attachmentType?.fileType || 'N/A' }} •
                            {{ attachment.createdAt | date: 'mediumDate' }}
                          </p>
                        </div>
                      </div>
                      <button
                        (click)="viewAttachment(attachment.uuid)"
                        class="rounded-lg p-2 text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-primary transition-colors cursor-pointer"
                        [disabled]="!attachment.uuid"
                      >
                        <mat-icon>visibility</mat-icon>
                      </button>
                    </div>
                  }
                }
              </div>
            </div>
          </div>

          @if (!isReadOnlyView) {
            <div class="col-span-12 lg:col-span-4 space-y-6">
              <approval-timeline></approval-timeline>

              @if (guaranteeUuid && workflow) {
                <div class="mt-3">
                  <app-approval-form
                    [title]="
                      pageTitle + ' Review (' + (workflow.currentStageName || 'Workflow') + ')'
                    "
                    [workflow]="workflow"
                    [businessKey]="guaranteeUuid"
                    [businessType]="businessType"
                  >
                  </app-approval-form>
                </div>
              } @else {
                <p class="text-[10px] text-center text-slate-400 italic">
                  Approval form will appear once workflow loads.
                </p>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
<custom-app-modal #modal></custom-app-modal>
